import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute } from "@angular/router";
import { VendorSummaryDto } from "../../../../core/models/vendor/summary/vendorSummaryDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { DrawerModule } from "primeng/drawer";
import { CommonModule } from "@angular/common";
import { ClientPurposeType } from "../../../../shared/enums/clientpurposetype";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { VendorService } from "../../../../core/services/vendor.service";
import { Contact } from "../../../../core/models/shared/contact";
import { ScrollPanelModule } from "primeng/scrollpanel";

@UntilDestroy()
@Component({
  selector: "jni-view-contact-information",
  templateUrl: "./view-contact-information.component.html",
  styleUrls: ["./view-contact-information.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, ScrollPanelModule, DrawerModule],
})
export class ViewContactInformationComponent implements OnInit {
  @Input() display!: boolean;
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() editEvent = new EventEmitter<Contact>();
  vendorContacts: Contact[] = [];
  vendorStatusId = "";
  vendorInformation?: VendorSummaryDto;
  vendorContactsInformation?: Contact[];
  businessObject: Contact | undefined;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("vendorIdFromModal")
  set vendorIdFromModal(value: string) {
    this.vendorStatusId = value;
  }

  constructor(
    private _vendorService: VendorService,
    public _loaderService: LoaderService,
    private router: ActivatedRoute
  ) {
    this.router.params.subscribe(params => {
      this.vendorStatusId = params["id"];
    });
  }

  ngOnInit(): void {
    this.getVendorInformationData();
  }

  onHide() {
    this.displayChange.emit(false);
  }

  getVendorInformationData() {
    if (this.vendorStatusId) {
      this._loaderService.setLoaderState(true);
      this._vendorService
        .getVendorInformation(this.vendorStatusId?.toString())
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.vendorInformation = res.data;
            if (this.vendorInformation?.contacts) {
              this.vendorContactsInformation = this.vendorInformation?.contacts;
            }

            this.transformVendorContactData();
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  transformVendorContactData() {
    const Vendor = this.vendorContactsInformation?.filter(
      x => x.purposeD365 == ClientPurposeType.Business
    );
    //this.populateVendorContactInformation(Vendor);
    this.groupByContactArray(Vendor);

    // const Inside = this.vendorContactsInformation?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Invoice
    // );
    // this.populateVendorContactInformation(Inside);
    const Website = this.vendorContactsInformation?.filter(
      x => x.purposeD365 == ClientPurposeType.Other
    );

    const inside = Website?.filter(x => x.otherSpecification === "Inside");
    this.groupByContactArray(inside);
    //this.populateVendorContactInformation(inside);

    const newwebsite = Website?.filter(x => x.otherSpecification === "Website");
    this.groupByContactArray(newwebsite);
    //this.populateVendorContactInformation(newwebsite);
  }

  groupByContactArray(contactArray: Contact[] | undefined) {
    let i = 0;
    const array: Contact[] = [];
    if (contactArray?.length) {
      while (i < contactArray?.length) {
        array.push(contactArray[i]);
        if (i % 2 !== 0) {
          this.populateVendorContactInformation(array);
          array.length = 0;
        }
        i++;
      }
    }
  }

  populateVendorContactInformation(vendorContacts: Contact[] | undefined) {
    if (
      vendorContacts != null &&
      vendorContacts != undefined &&
      vendorContacts.length > 0
    ) {
      const vendorContact: Contact = {
        otherSpecification: "",
        createdDate: "",
        createdBy: "",
        lastModifiedDate: null,
        lastModifiedBy: null,
        isActive: false,
      };
      const name = vendorContacts[0]?.firstNameD365;
      vendorContact.purposeD365 = vendorContacts[0].purposeD365;
      vendorContact.isPrimaryD365 = vendorContacts[0].isPrimaryD365;
      vendorContact.nameD365 =
        vendorContacts[0].descriptionD365 === ""
          ? name
          : vendorContacts[0].descriptionD365;
      // vendorAddress.electronicAddressIdD365 =
      //   vendorContacts[0].electronicAddressIdD365;
      vendorContact.otherSpecification =
        vendorContacts[0].otherSpecification ?? "";
      if (
        vendorContacts.find(x => x.typeD365 == EnumContactType.Phone) !=
        undefined
      ) {
        vendorContact.phone =
          vendorContacts.find(x => x.typeD365 == EnumContactType.Phone)
            ?.locatorD365 ?? "";
        vendorContact.phoneLink =
          "tel:'" +
          vendorContacts.find(x => x.typeD365 == EnumContactType.Phone)
            ?.locatorD365 +
          "'";
        vendorContact.electronicAddressPhone = vendorContacts.find(
          x =>
            x.typeD365 == EnumContactType.Phone &&
            x?.electronicAddressIdD365 !== ""
        )?.electronicAddressIdD365;

        vendorContact.portalKeyPhone = vendorContacts.find(
          x => x.typeD365 == EnumContactType.Phone && x?.portalKeyD365 !== ""
        )?.portalKeyD365;
      }
      if (
        vendorContacts.find(x => x.typeD365 == EnumContactType.Email) !=
        undefined
      ) {
        vendorContact.email = vendorContacts.find(
          x => x.typeD365 == EnumContactType.Email
        )?.locatorD365;
        vendorContact.emailLink =
          "mailto:'" +
          vendorContacts.find(x => x.typeD365 == EnumContactType.Email)
            ?.locatorD365 +
          "'";
        vendorContact.electronicAddressEmail = vendorContacts.find(
          x =>
            x.typeD365 == EnumContactType.Email &&
            x?.electronicAddressIdD365 !== ""
        )?.electronicAddressIdD365;
      }

      vendorContact.portalKeyEmail = vendorContacts.find(
        x => x.typeD365 == EnumContactType.Email && x?.portalKeyD365 !== ""
      )?.portalKeyD365;

      this.vendorContacts.push(vendorContact);
    }

    if (this.vendorContacts != undefined) {
      if (this.vendorContacts.length > 0) {
        this.businessObject = this.vendorContacts.find(
          x => x.purposeD365 === "Business"
        );
      }
    }
  }

  openEditContact(event: Contact) {
    this.editEvent.emit(event);
  }
}
